module.exports = __webpack_public_path__ + "img/telegram-reg.eb970e54.svg";